/**
 * Created by admin on 2018/7/30.
 */
import * as accountService from '../services/account';
import { PATHS, REPORT_ACTIVE_TYPE } from '../utils/constants';

export default {
  namespace: 'support',
  state: {
    allSupports: [],
    frontDeskPhone: ''
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    }
  },
  effects: {
    *findAllSupports(_, { call, put }) {
      const { data: allSupports = [], status } = yield call(
        accountService.getAllSupports
      );
      if (status === 0 && allSupports) {
        yield put({ type: 'update', payload: { allSupports } });
      }
    },
    *findFrontDeskPhone(_, { call, put }) {
      const { data: frontDeskPhone, status } = yield call(
        accountService.findFrontDeskPhone
      );
      if (status === 0) {
        yield put({ type: 'update', payload: { frontDeskPhone } });
      }
    },
    *updateFrontDeskPhone({ resolve, reject }, { call, select }) {
      const { frontDeskPhone } = yield select(state => state.support);
      const { userId: optId } = yield select(state => state.login.userInfo);
      const { msg, status } = yield call(
        accountService.updateFrontDeskPhone,
        frontDeskPhone
      );
      const params = {
        operatorId: optId,
        actType: REPORT_ACTIVE_TYPE.FRONT_DESK,
        optResult: status,
        actContent: `设置前台号码[${frontDeskPhone}]操作成功`
      };
      if (status === 0) {
        resolve && resolve();
      } else {
        params.actContent = `设置前台号码[${frontDeskPhone}]操作失败: ${msg}`;
        reject && reject(msg);
      }
      yield call(accountService.recordActivityLog, params);
    },
    *save(
      { supportId = '', name = '', resolve, reject },
      { call, put, select }
    ) {
      const { userId: optId } = yield select(state => state.login.userInfo);
      const { status, msg } = yield call(accountService.saveSupport, {
        supportId,
        name
      });
      const params = {
        operatorId: optId,
        actType:
          supportId > 0
            ? REPORT_ACTIVE_TYPE.MOD_SUPPORT
            : REPORT_ACTIVE_TYPE.ADD_SUPPORT,
        optResult: status,
        actContent: `${
          supportId > 0 ? '修改' : '新增'
        }会议支持项[${name}]操作成功`
      };
      if (status === 0) {
        yield put({ type: 'findAllSupports' });
        resolve && resolve();
      } else {
        params.actContent = `${
          supportId > 0 ? '修改' : '新增'
        }会议支持项[${name}]操作失败: ${msg}`;
        reject && reject(msg);
      }
      yield call(accountService.recordActivityLog, params);
    },
    *delete({ supportId, resolve, reject }, { select, call, put }) {
      const { userId: optId } = yield select(state => state.login.userInfo);
      const { status, msg } = yield call(
        accountService.deleteSupport,
        supportId
      );
      const params = {
        operatorId: optId,
        actType: REPORT_ACTIVE_TYPE.DEL_SUPPORT,
        optResult: status,
        actContent: `删除会议支持项[ID=${supportId}]操作成功`
      };
      if (status === 0) {
        yield put({ type: 'findAllSupports' });
        resolve && resolve();
      } else {
        params.actContent = `删除会议支持项[ID=${supportId}]操作失败: ${msg}`;
        reject && reject(msg);
      }
      yield call(accountService.recordActivityLog, params);
    }
  },

  subscriptions: {
    set({ dispatch, history }) {
      return history.listen(({ pathname }) => {
        if (pathname === PATHS.supportManage) {
          dispatch({ type: 'findAllSupports' });
          dispatch({ type: 'findFrontDeskPhone' });
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/models/support.js